import Administration from "./administration";

export default Administration;
